import { useTheme, Box } from '@chakra-ui/react';
import React, { useState } from 'react';
import { styles } from './styles';
import Navbar from './headerComps/navbar/navbar';
import GestarWhiteLogo from '../../vectors/gestarWhiteLogo';
import CampusVirtual from './headerComps/campusVirtual/campusVirtual';
import { Link } from 'react-router-dom';
import { useAppContext } from '../../App';
import { HamburgerIcon } from '@chakra-ui/icons';
import SearcherCustom from '../searcherCustom/searcherCustom';


export default function Header({ mode, setMode, bannerVisible }) {
  const theme = useTheme();
  const {isMobile, toggleDrawer, searcherText} = useAppContext();
  const style = styles(theme, isMobile);
  const [hasLeavedHeader, setHasLeavedHeader] = useState(false);

  return (
    <Box
    id="top-of-paths"
    position="fixed"
    top={bannerVisible ? "48px" : "0"}
    left="0"
    width="100%"
    zIndex="1000"
    bg="white"
    boxShadow="sm"
    style={style.headerContainer}
    onMouseLeave={() => setHasLeavedHeader(true)}
    onMouseOver={() => setHasLeavedHeader(false)}
  >
      <Link to={'/'}>
        <GestarWhiteLogo viewBox={"200 200 800 200"} style={style.whiteLogo}/>
      </Link>
      {!isMobile && <Navbar hasLeavedHeader={hasLeavedHeader}/>}
     {/* {!isMobile && <Box ml="2rem" />}  Espacio entre Navbar y Searcher */}
      {/* 
      {!isMobile && (
        <SearcherCustom
          from={'header'} 
          inheritSearch={searcherText} 
          customStyles={{
            container:{
              minWidth: isMobile? "30vw":"2vw",
              backgroundColor: 'transparent',
              boxShadow: 'none',
            },
            input:{
              borderWith: 10,
              marginLeft: isMobile? '-6rem': 0,
              borderColor: theme.color.text.tertiary
            }
          }}
        />
      )}
      */}
      {isMobile && <HamburgerIcon marginLeft={'-3rem'} color={theme.color.text.primary} fontSize={30} onClick={toggleDrawer}/>}
      {!isMobile && <CampusVirtual from={"header"}/>}
</Box>
  )
}
